import React from 'react';

const PaypalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 18 24"
    fill="none"
  >
    <path
      d="M5.22188 13.8703C5.05782 14.7703 4.40626 18.9656 4.21407 20.1516C4.20001 20.2359 4.16719 20.2688 4.07344 20.2688H0.57657C0.22032 20.2688 -0.0374929 19.9594 0.00938213 19.6172L2.75626 2.18438C2.82657 1.73438 3.22969 1.39219 3.69376 1.39219C10.8328 1.39219 11.4328 1.21875 13.2563 1.92656C16.0734 3.01875 16.3313 5.65313 15.3188 8.50313C14.3109 11.4375 11.9203 12.6984 8.75157 12.7359C6.71719 12.7688 5.49376 12.4078 5.22188 13.8703ZM16.7391 7.125C16.6547 7.06406 16.6219 7.04063 16.5984 7.18594C16.5047 7.72031 16.3594 8.24063 16.1859 8.76094C14.3156 14.0953 9.13126 13.6313 6.60001 13.6313C6.31407 13.6313 6.12657 13.7859 6.08907 14.0719C5.02969 20.6531 4.81876 22.0266 4.81876 22.0266C4.77188 22.3594 4.98282 22.6313 5.31563 22.6313H8.29219C8.69532 22.6313 9.02813 22.3359 9.10782 21.9328C9.14063 21.6797 9.05626 22.2188 9.78282 17.6531C9.99844 16.6219 10.4531 16.7297 11.1563 16.7297C14.4844 16.7297 17.0813 15.3797 17.8547 11.4656C18.1594 9.83438 18.0703 8.11875 16.7391 7.125Z"
      fill="#2B2D42"
    />
  </svg>
);
export default PaypalIcon;
